import * as types from './types';

const INITIAL_STATE = {
  truckRouteScheduleListData: [],
  truckRouteScheduleDataLoading: false,
  truckRouteListDataLoadingError: null,
  deleteTruckRouteScheduleSuccess: null,
  deleteTruckRouteScheduleLoading: false,
  deleteTruckRouteScheduleError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_TRUCK_ROUTE_SCHEDULE_LIST:
      return { ...state, truckRouteScheduleListData: action.payload };
    case types.GET_TRUCK_ROUTE_SCHEDULE_LIST_LOADING:
      return { ...state, truckRouteScheduleDataLoading: action.payload };
    case types.GET_TRUCK_ROUTE_SCHEDULE_LIST_LOADING_ERROR:
      return { ...state, truckRouteScheduleDataLoadingError: action.payload };
    case types.DELETE_TRUCK_ROUTE_SCHEDULE:
      return { ...state, deleteTruckRouteScheduleSuccess: action.payload };
    case types.DELETE_TRUCK_ROUTE_SCHEDULE_LOADING:
      return { ...state, deleteTruckRouteScheduleLoading: action.payload };
    case types.DELETE_TRUCK_ROUTE_SCHEDULE_ERROR:
      return { ...state, deleteTruckRouteScheduleError: action.payload };
    case types.CLEAR_TRUCK_ROUTE_SCHEDULE_LIST_ERROR:
      return {
        ...state,
        truckRouteScheduleDataLoadingError: null,
        deleteTruckRouteScheduleError: null,
      };
    case types.CLEAR_DELETE_TRUCK_ROUTE_SCHEDULE_SUCCESS:
      return { ...state, deleteTruckRouteScheduleSuccess: null };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/managetruckrouteschedulelist/reducer.js